// extracted by mini-css-extract-plugin
export default {"modal":"ManageSeriesModal_modal__m0xfV","modalHeader":"ManageSeriesModal_modalHeader__vkHF+"};